<template>
  <PageTemplate :loading="loading">
    <v-container class="pt-10 pb-12">
      <Title>Nasci no H2P</Title>

      <v-row v-if="items.length" class="mt-6 mt-sm-8">
        <LightGallery
          v-if="images.length"
          :images="images"
          :index="index"
          :disable-scroll="true"
          @close="index = null"
        />

        <v-col cols="12" sm="6" md="4" v-for="(item, key) in items" :key="key">
          <div @click="index = key">
            <NewBornsCard :item="item" />
          </div>
        </v-col>

        <v-col v-if="pagesLength > 1" class="mt-10" cols="12">
          <v-pagination
            v-model="page"
            :length="pagesLength"
            :total-visible="totalVisibles"
          ></v-pagination>
        </v-col>
      </v-row>

      <v-alert v-else type="warning" class="mt-10">
        Nenhum item adicionado até o momento.
      </v-alert>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Title from "../../widgets/Title.vue";
import NewBornsCard from "../../cards/NewBorns.vue";
import { LightGallery } from "vue-light-gallery";

const _config = {
  mod: "projects-newborns",
};

export default {
  data: () => ({
    loading: true,
    items: [],
    images: [],
    index: null,
    itemsPerPage: 24,
    totalItems: 0,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    totalVisibles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 5;
        default:
          return 9;
      }
    },
  },
  created() {
    this.get();
  },
  watch: {
    page() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.page) params.page = this.page;

      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(({ img, title }) => ({
              img,
              title,
            }));

            const images = [];

            list.map(({ img }) => {
              images.push(this.files + img);
            });

            this.images = images;

            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    PageTemplate,
    Title,
    NewBornsCard,
    LightGallery,
  },
};
</script>
